import { render, staticRenderFns } from "./VerifiedBadgeIcon.vue?vue&type=template&id=4f26879b"
import script from "./VerifiedBadgeIcon.vue?vue&type=script&lang=js"
export * from "./VerifiedBadgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports